import { render, staticRenderFns } from "./AddDataSynonyms.vue?vue&type=template&id=1922d902&"
import script from "./AddDataSynonyms.vue?vue&type=script&lang=js&"
export * from "./AddDataSynonyms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports